import { render, staticRenderFns } from "./CoAddPlanResource.vue?vue&type=template&id=4903eb12&scoped=true&"
import script from "./CoAddPlanResource.vue?vue&type=script&lang=ts&"
export * from "./CoAddPlanResource.vue?vue&type=script&lang=ts&"
import style0 from "./CoAddPlanResource.vue?vue&type=style&index=0&id=4903eb12&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4903eb12",
  null
  
)

export default component.exports